var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#605E5C",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6H15C15.2761 6 15.5 6.22386 15.5 6.5C15.5 6.77614 15.2761 7 15 7H14.4475L13.6946 13.7761C13.5539 15.0422 12.4838 16 11.2099 16H8.79008C7.51621 16 6.44605 15.0422 6.30537 13.7761L5.55247 7H5C4.72386 7 4.5 6.77614 4.5 6.5C4.5 6.22386 4.72386 6 5 6H8C8 4.89543 8.89543 4 10 4C11.1046 4 12 4.89543 12 6ZM10 5C9.44772 5 9 5.44772 9 6H11C11 5.44772 10.5523 5 10 5ZM8.5 9L8.5 13C8.5 13.2761 8.72386 13.5 9 13.5C9.27614 13.5 9.5 13.2761 9.5 13L9.5 9C9.5 8.72386 9.27614 8.5 9 8.5C8.72386 8.5 8.5 8.72386 8.5 9ZM11 8.5C10.7239 8.5 10.5 8.72386 10.5 9V13C10.5 13.2761 10.7239 13.5 11 13.5C11.2761 13.5 11.5 13.2761 11.5 13V9C11.5 8.72386 11.2761 8.5 11 8.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.0ea9ece7daf9b18891a719771987fa52.svg";
export { ForwardRef as ReactComponent };